query justicaSelect {
    data: justicas(order: [{nome: ASC}]) {
        value: codigo
        label: nome
    }
}